import React from 'react'
import { useRisks } from 'src/pages/Risks/risks.hooks'
import { NONE_ID, NONE_NAME } from 'src/Utils/globalConstants'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'

export const DashboardRiskFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: risks } = useRisks()
  const noRiskValue = {
    value: NONE_ID,
    label: NONE_NAME,
  }
  const filterValues = [
    noRiskValue,
    ...(risks?.getRisksList()?.map((risk) => ({
      value: risk.getName(),
      label: risk.getName(),
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_RISK}
      filterName={FilterName.DASHBOARD_RISK}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
